/* SearchDropdownEmbedded.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["showFocused"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["isPlaceHolder"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _28 = "._syaz1kw7{color:inherit}";
const _27 = "._1ygb4suz:focus-visible{outline:2px solid var(--ds-border-focused)}";
const _26 = "._1yt41val{padding:var(--ds-space-100) var(--ds-space-400) var(--ds-space-100) var(--ds-space-200)}";
const _25 = "._11q71xnl{background:var(--ds-background-input)}";
const _24 = "._19it1vvc{border:2px solid var(--ds-border-input)}";
const _23 = "._1wyb1j6v{font-size:1rem}";
const _22 = "._vwz41j6v{line-height:1rem}";
const _21 = "._ect48q0o{font-family:Charlie Text}";
const _20 = "._16qs1402{box-shadow:0 0 1px 0 rgba(9,30,66,.31),0 3px 5px 0 rgba(9,30,66,.2)}";
const _19 = "._1pbykb7n{z-index:1}";
const _18 = "._154i1ady{top:44px}";
const _17 = "._kqswstnw{position:absolute}";
const _16 = "._2rkoftgi{border-radius:8px}";
const _15 = "._1bsb1osq{width:100%}";
const _14 = "._bfhkipex{background-color:var(--ds-surface-overlay)}";
import SearchIcon from '@atlaskit/icon/glyph/search';
import { media } from '@atlaskit/primitives/responsive';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useHistory, useLocationHref, useQueryParams } from '@atlassian/mpac-ui';
import { useMountPath, useSource } from '@atlassian/mpac-utils';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAlgoliaAutocomplete } from '../../AlgoliaClientSDK/useAlgoliaAutocomplete';
import { getSuggestionSource } from '../../AnalyticsUtils';
import { embeddedPlaceholder, inProductPlaceholder, mobilePlaceholder } from '../../constants';
import { RecentSearch } from '../../SearchUtils';
import { redirectToNewQuery } from '../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
import { SearchBodyFactory } from '../SearchBodyFactory';
import { SearchHeader } from '../SearchHeader';
import { useAutocompleteState } from './hooks/useAutocompleteState';
import { useOutsideClick } from './hooks/useOutsideClick';
import { useSearchDropdown } from './hooks/useSearchDropdown';
import { useSearchViewAnalytics } from './hooks/useSearchViewAnalytics';
const _13 = "._1h6d4emh{border-color:var(--ds-border-input)}";
const _12 = "._1h6d1oj9{border-color:var(--ds-border-selected)}";
const _11 = "@media (min-width:64rem){._1yag1dzv{padding:var(--ds-space-100) var(--ds-space-150)}}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._bfhk6ota{background-color:var(--ds-surface)}";
const _8 = "._19it1axk{border:2px solid}";
const _7 = "._2rkoi2wt{border-radius:6px}";
const _6 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _5 = "._zulp1eps{gap:var(--ds-space-100)}";
const _4 = "._vchhusvi{box-sizing:border-box}";
const _3 = "._1e0c1txw{display:flex}";
const _2 = "._1yt41eps{padding:var(--ds-space-100)}";
const _ = "._4t3i1ylp{height:40px}";
const Header = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      showFocused
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3i1ylp _1yt41eps _1e0c1txw _vchhusvi _zulp1eps _syaz1jij _2rkoi2wt _19it1axk _bfhk6ota _4cvr1h6o _1yag1dzv", __cmplp.showFocused ? "_1h6d1oj9" : "_1h6d4emh", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
const SearchBodyWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_14, _15, _16, _17, _18, _19, _20]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_bfhkipex _1bsb1osq _2rkoftgi _kqswstnw _154i1ady _1pbykb7n _16qs1402", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchBodyWrapper.displayName = 'SearchBodyWrapper';
}
const SearchEmbeddedDropdown = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedDropdown.displayName = 'SearchEmbeddedDropdown';
}
const SearchButtonMobile = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  const {
      isPlaceHolder
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _, _15, _21, _22, _23, _5, _7, _24, _25, _10, _26, _27, _6, _28]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _4t3i1ylp _1bsb1osq _ect48q0o _vwz41j6v _1wyb1j6v _zulp1eps _2rkoi2wt _19it1vvc _11q71xnl _4cvr1h6o _1yt41val _1ygb4suz", __cmplp.isPlaceHolder ? "_syaz1jij" : "_syaz1kw7", __cmplp.className])
  })));
});

// RECENT SEARCH HANDLINGS
if (process.env.NODE_ENV !== 'production') {
  SearchButtonMobile.displayName = 'SearchButtonMobile';
}
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');
// eslint-disable-next-line max-lines-per-function
export function SearchDropdownEmbedded(_ref5) {
  var _searchPlaceholder$de;
  let {
    searchInputRef,
    onInputFocus,
    onViewed,
    onSuggestionSelection,
    onEnterKeyPress,
    additionalQueryParams,
    searchPlaceholder
  } = _ref5;
  const searchembeddedRef = useRef(null);
  const [showSuggestionPopup, setShowSuggestionPopup] = React.useState(false);
  const [showFocused, setShowFocused] = React.useState(false);
  const searchSuggestionCountRef = useRef(0);
  const hasFiredViewedAnalyticsRef = useRef(false);
  const source = useSource();
  const mountPath = useMountPath();

  // LOCATION HANDLINGS
  const {
    query: queryFromUrl
  } = useQueryParams();
  const locationHref = useLocationHref();
  const history = useHistory();

  // AUTOCOMPLETE HANDLINGS
  const ref = useRef(null);
  const inputRef = searchInputRef !== null && searchInputRef !== void 0 ? searchInputRef : ref;
  const handleNewSearch = useCallback(hit => {
    var _inputRef$current, _hit$__autocomplete_i, _inputRef$current2;
    const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
    onSuggestionSelection({
      query: hit.query,
      position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
      popularity: hit.popularity,
      suggestionSource: getSuggestionSource(!!inputValue),
      count: inputValue ? searchSuggestionCountRef.current : recentSearch.count()
    });
    recentSearch.push(hit);

    // The following code resolves a bug experienced in SRP. Previously, when the input field text was cleared,
    // reselecting the same text from the recent search list did not repopulate the input field.
    // The function setQuery() is used to set the selected hit in the autocomplete object.
    autocomplete.setQuery(hit.query);
    redirectToNewQuery({
      query: hit.query,
      locationHref,
      history,
      additionalQueryParams,
      source,
      mountPath
    });
    setShowSuggestionPopup(false);
    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
  }, [onSuggestionSelection, locationHref, history, additionalQueryParams]);
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const showFullScreenComponent = breakpoint <= breakpointValues.sm;
  const {
    autocomplete,
    autocompleteState
  } = useAlgoliaAutocomplete(inputRef,
  // we only need to set the placeholder for the desktop view using Algolia Client SDK,
  // for mobile view a button is rendered which opens SearchDropdownOverlay Component
  source === 'PRODUCT' ? inProductPlaceholder : (_searchPlaceholder$de = searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.desktop) !== null && _searchPlaceholder$de !== void 0 ? _searchPlaceholder$de : embeddedPlaceholder, queryFromUrl, handleNewSearch, recentSearch);

  // hide suggestions on clicking outside search embedded component
  useOutsideClick(searchembeddedRef, () => setShowSuggestionPopup(false));
  const {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  } = useSearchDropdown({
    inputRef,
    autocomplete,
    autocompleteState,
    recentSearch,
    onEnterKeyPress,
    additionalQueryParams
  });

  // BODY STATE HANDLINGS
  const {
    bodyState
  } = useAutocompleteState({
    autocompleteState
  });
  const searchSuggestionProps = {
    hits: autocompleteState.collections,
    autocomplete,
    onAppend: handleAppend
  };
  useEffect(() => {
    var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
    searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
  }, [bodyState, autocompleteState]);
  useSearchViewAnalytics({
    showSuggestionPopup,
    inputRef,
    isQueryFromUrl: !!queryFromUrl,
    onViewed,
    recentSearch,
    hasFiredViewedAnalyticsRef,
    autocompleteState,
    bodyState
  });
  const showSuggestionView = useCallback(() => {
    hasFiredViewedAnalyticsRef.current = false;
    setShowSuggestionPopup(true);
    setShowFocused(true);
    if (showFullScreenComponent) {
      onInputFocus();
    }
  }, [onInputFocus, showFullScreenComponent]);
  const onKeyDown = e => {
    if (e.key === 'Tab' && e.shiftKey) {
      var _inputRef$current3;
      setShowSuggestionPopup(false);
      (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.blur();
    }
    if (e.key === 'ArrowDown') {
      showSuggestionView();
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Tab') {
      var _inputRef$current4;
      setShowSuggestionPopup(false);
      (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.blur();
    }
  };
  const onFocus = () => {
    if (!isMobile) {
      showSuggestionView();
    }
  };
  const onBlur = e => {
    if (searchembeddedRef.current && !searchembeddedRef.current.contains(e.relatedTarget)) {
      setShowSuggestionPopup(false);
    }
  };
  const onFormSubmit = query => {
    handleEnterKeyPress(query);
    setShowSuggestionPopup(false);
  };
  const {
    value: searchText
  } = autocomplete.getInputProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
  });
  if (isMobile) {
    return /*#__PURE__*/React.createElement(SearchButtonMobile, {
      onClick: showSuggestionView,
      "aria-label": "Search",
      isPlaceHolder: !searchText
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      label: "search"
    }), searchText || (searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.mobile) || mobilePlaceholder);
  }
  return /*#__PURE__*/React.createElement(SearchEmbeddedDropdown, {
    ref: searchembeddedRef,
    onBlur: onBlur,
    tabIndex: -1,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement(Header, {
    showFocused: showFocused
  }, /*#__PURE__*/React.createElement(SearchHeader, {
    autocomplete: autocomplete,
    ref: inputRef,
    handleEnterKeyPress: onFormSubmit,
    clearSearchInput: clearSearchInput,
    onBlur: () => setShowFocused(false),
    onFocus: onFocus,
    isEmbedded: true,
    showFullScreenComponent: showFullScreenComponent,
    onClearTextKeyDown: onKeyDownHandler
  })), showSuggestionPopup && /*#__PURE__*/React.createElement(SearchBodyWrapper, {
    role: "status",
    "aria-live": "assertive",
    "aria-relevant": "additions"
  }, /*#__PURE__*/React.createElement(SearchBodyFactory, {
    type: bodyState,
    searchQuerySuggestionsBodyProps: _objectSpread({
      query: autocompleteState.query
    }, searchSuggestionProps),
    searchLoadingProps: {
      query: autocompleteState.query
    },
    recentSearchBodyProps: _objectSpread({
      onClearAll: clearRecentSearches,
      onKeyDown: onKeyDownHandler
    }, searchSuggestionProps),
    noSuggestionsBodyProps: {
      query: autocompleteState.query
    }
  })));
}